import { type Quantity } from '@luminovo/api-contracts';
import { formatQuantity } from '@luminovo/data-stack';

/** @deprecated Use `formatQuantity` from `@luminovo/data-stack` directly. */
export function formatUnitOfMeasurement(unitOfMeasurement: Quantity): string {
    return formatQuantity(unitOfMeasurement, { showPiecesUnit: true });
}
